'use client';
// import { fetchPost } from 'eco-design-micro/request/FetchClient';
import { getReqHeaders } from 'eco-design-micro/utils/getReqHeaders';
import { CookieDataExtendType } from 'eco-design-reliance/cookies/type.d';
import { subscribeCookie } from 'eco-design-reliance/cookies/subscribeCookie';

const API_HOST_US = 'https://api-a.ecoflow.com/website';
const API_HOST_CN = 'https://api-e.ecoflow.com/website';
const API_HOST_EU = 'https://api-cn.ecoflow.com/website';
const data_center_eu = ['de', 'it', 'uk', 'fr', 'cis', 'es', 'eu', 'za', 'sa', 'jp', 'kr'];
const data_center_cn = ['cn'];

export const getBaseUrl = (locale = 'us') => {
    if (data_center_eu.includes(locale)) {
        return API_HOST_EU;
    } else if (data_center_cn.includes(locale)) {
        return API_HOST_CN;
    }
    return API_HOST_US;
};

export const fetchPost = async (url: string, locale: string, params: any, options?: any) => {
    const API_HOST = getBaseUrl(locale);
    const options2 = options || {};
    const headers1 = getReqHeaders(locale);
    const headers2 = options2.headers || {};
    headers1['Accept'] = 'application/json';
    headers1['Content-Type'] = 'application/json';
    const res = await fetch(`${API_HOST}${url}`, {
        method: 'POST',
        headers: {
            ...headers1,
            ...headers2,
        },
        body: JSON.stringify(params || {}),
        next: { revalidate: 300 },
    });

    return res.json();
};

export const sendMultiEmarsysEmail = async (locale: string, data: any, subscribeData?: CookieDataExtendType | undefined) => {
    const obj = {
        sector_name: 'Banner',
        entry_position: 1,
    } as CookieDataExtendType;

    if (subscribeData) {
        (Object.keys(subscribeData) as Array<keyof CookieDataExtendType>)?.map((k: keyof CookieDataExtendType) => {
            if (k && subscribeData[k]) {
                obj[k] = subscribeData[k];
            }
        });
    }

    const res = await fetchPost(`/subscribe/new`, locale, subscribeData ? { ...data, eventTracking: subscribeCookie(obj) } : data, {
        headers: {
            apiKey: '527760f6df93c0d6e98609fa8e8a1f4a',
        },
    });
    return res;
};
